import { render, staticRenderFns } from "./suporte-equipamentos.vue?vue&type=template&id=4ce33414"
import script from "./suporte-equipamentos.vue?vue&type=script&lang=ts"
export * from "./suporte-equipamentos.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports